import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

const GET_PAYSLIPS = gql`
  query Payslips($sliceNumber: Int!) {
    payslips(payslipsRequest: { sliceNumber: $sliceNumber }) {
      payslips {
        uuid
        payslipFileUuid
        year
        month
        currency
        grossSalary
        netSalary
        taxes
        createdAt
        bonus
        paymentDate
        employerContributions
        employeeContributions
        comment
      }
      hasNext
    }
  }
`;

export const usePayslips = (sliceNumber) => {
  const { loading, error, data, refetch } = useQuery(GET_PAYSLIPS, {
    variables: { sliceNumber },
    fetchPolicy: "network-only",
  });

  return { loading, error, data: data?.payslips, refetch };
};
